module.exports = __webpack_public_path__ + "static/media/grip-plus.f70f6a89.svg";